import React from "react";
import ShowGroupColors from "./__ShowGroupColors";
import colorGroups from "./__ColorGroups";

const accentColors = colorGroups.find(
  (group) => group.group === "Accent Colors"
);

const AccentSection: React.FC = () => (
  <section className="w-full flex flex-col items-center my-12 bg-bg-base px-4">
    <div className="container mx-auto max-w-6xl py-20">
      <div className="flex items-center justify-center">
        <img
          src="/images/logo-square.png"
          alt="RepMates logo"
          width="512"
          height="512"
          className="w-24 h-auto"
        />
      </div>

      <h1 className="text-5xl md:text-7xl font-extrabold text-tx-dark text-center leading-tight mb-10">
        Accent Colors
      </h1>
      {/* ACCENT CARDS SECTION */}
      <div className="w-full grid grid-cols-2 lg:grid-cols-4 gap-2">
        {/* Card Hot*/}
        <div className="flex-1 rounded-3xl bg-accent-bg-hot  p-8 md:p-10 flex flex-col justify-between  shadow-md">
          <span className="inline-block bg-white text-accent-bg-hot text-sm font-semibold px-5 py-2 rounded-full mb-6 w-fit">
            Accent Hot
          </span>
          <div className="flex-1">
            <div className="text-lg md:text-xl font-extrabold text-accent-fg-hot mb-4 leading-tight">
              Accent Hot As
              <br />
              Background
            </div>
          </div>
          {/* Progress Bar */}
          <div className="w-full bg-accent-fg-hot/20 rounded-full h-5 mt-6 px-2 flex items-center">
            <div
              className="bg-accent-fg-hot h-3 rounded-full"
              style={{ width: "10%" }}
            ></div>
          </div>
        </div>
        {/* Card Warm*/}
        <div className="flex-1 rounded-3xl bg-accent-bg-warm p-8 md:p-10 flex flex-col justify-between  shadow-md">
          <span className="inline-block bg-white text-accent-bg-warm text-sm font-semibold px-5 py-2 rounded-full mb-6 w-fit">
            Accent Warm
          </span>
          <div className="flex-1">
            <div className="text-lg md:text-xl font-extrabold text-accent-fg-warm mb-4 leading-tight">
              Accent Warm As
              <br />
              Background
            </div>
          </div>
          {/* Progress Bar */}
          <div className="w-full bg-accent-fg-warm/20 rounded-full h-5 mt-6 px-2 flex items-center">
            <div
              className="bg-accent-fg-warm h-3 rounded-full"
              style={{ width: "35%" }}
            ></div>
          </div>
        </div>
        {/* Card Cool*/}
        <div className="flex-1 rounded-3xl bg-accent-bg-cool p-8 md:p-10 flex flex-col justify-between  shadow-md">
          <span className="inline-block bg-white text-accent-bg-cool text-sm font-semibold px-5 py-2 rounded-full mb-6 w-fit">
            Accent Cool
          </span>
          <div className="flex-1">
            <div className="text-lg md:text-xl font-extrabold text-accent-fg-cool mb-4 leading-tight">
              Accent Cool As
              <br />
              Background
            </div>
          </div>
          {/* Progress Bar */}
          <div className="w-full bg-accent-fg-cool/20 rounded-full h-5 mt-6 px-2 flex items-center">
            <div
              className="bg-accent-fg-cool h-3 rounded-full"
              style={{ width: "55%" }}
            ></div>
          </div>
        </div>

        {/* Card Cold*/}
        <div className="flex-1 rounded-3xl bg-accent-bg-cold p-8 md:p-10 flex flex-col justify-between  shadow-md">
          <span className="inline-block bg-white text-accent-bg-cold text-sm font-semibold px-5 py-2 rounded-full mb-6 w-fit">
            Accent Cold
          </span>
          <div className="flex-1">
            <div className="text-lg md:text-xl font-extrabold text-accent-fg-cold mb-4 leading-tight">
              Accent Cold As
              <br />
              Background
            </div>
          </div>
          {/* Progress Bar */}
          <div className="w-full bg-accent-fg-cold/20 rounded-full h-5 mt-6 px-2 flex items-center">
            <div
              className="bg-accent-fg-cold h-3 rounded-full"
              style={{ width: "85%" }}
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div className="container mx-auto max-w-4xl py-20">
      <div className="w-full bg-bg-overlay rounded-lg p-4 md:p-20">
        {accentColors && <ShowGroupColors colorGroup={accentColors} />}
      </div>
    </div>
  </section>
);

export default AccentSection;
